import React, { useState } from "react"

// import ModalConsult from "./ModalConsult"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
// import { navigate } from "gatsby"

const FormService = ({ slug, title, price, lang }) => {
  const [validated, setValidated] = useState(false)

  const handleSubmit = event => {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }
  return (
    <Form
      data-netlify="true"
      netlify-honeypot="bot-field"
      action="/dyakuemo/"
      method="POST"
      name={slug}
      form-name={slug}
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
      lang={lang}
      id="serviceForm"
    >
      <Form.Group hidden>
        <input type="hidden" name="form-name" value={slug} />
        <Form.Label>
          Поле для незаполнения <Form.Control type="text" name="bot-field" />
        </Form.Label>
        <Form.Label>
          Сторінка{" "}
          <Form.Control
            type="hidden"
            placeholder="Сторінка"
            name="page"
            value={title}
          />
        </Form.Label>
        <Form.Label>
          Ціна{" "}
          <Form.Control
            type="hidden"
            placeholder="Ціна"
            name="price"
            value={price}
          />
        </Form.Label>
      </Form.Group>

      <Form.Group controlId="formPhone">
        <Form.Label>Телефон *</Form.Label>
        <Form.Control type="tel" placeholder="+380" name="phone" required />
        <Form.Control.Feedback type="invalid">
          {lang === "ru"
            ? `укажите номер, пожалуйста`
            : `вкажіть номер, будь ласка`}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formName">
        <Form.Label>{lang === "ru" ? `Имя` : `Ім'я`}</Form.Label>
        <Form.Control
          type="text"
          placeholder={
            lang === "ru" ? `как к Вам обратиться?` : `як до Вас звернутися?`
          }
          name="name"
        />
      </Form.Group>

      <Form.Group controlId="formCheckbox" className="mt-5">
        <Form.Check
          type="checkbox"
          label={
            lang === "ru" ? `соглашаюсь с правилами *` : `згода з правилами *`
          }
          name="agree"
          required
        />
        <Form.Control.Feedback type="invalid">
          {lang === "ru"
            ? `примите, пожалуйста, правила сайта *`
            : `прийміть, будь ласка, правила сайту *`}
        </Form.Control.Feedback>
      </Form.Group>
      <Row className="pb-5 mb-5">
        <Col>
          <Button variant="warning" type="submit" size="lg" block>
            {lang === "ru" ? `Отправить` : `Надіслати`}
          </Button>
        </Col>
        {/* <Col className="mt-3 mt-md-0"> */}
        {/* <ModalConsult buttonClass="form-consult-btn" buttonVariant="link" buttonText={lang === "ru" ? `Консультация` : `Консультація`} slug={slug} title={title} price={price} /> */}
        {/* </Col> */}
      </Row>
    </Form>
  )
}

FormService.defaultProps = {
  slug: ``,
  title: ``,
  price: `0`,
}

export default FormService
